import React, {useEffect, useState} from "react";
import { Button, Container, Grid, Select, Autocomplete, FormControl, InputLabel, MenuItem} from "@mui/material";


export const NumberOfUnitsControl = ({value, setValue, maxUnits, values, ...props}) => {

  const buildOptions = () => {
    if (values != null && values.length > 0){
      let toReturn = [];
      values.forEach(x => {
        toReturn.push(<MenuItem key={x} value={x}>{x} Units</MenuItem>)
      })
    }
    let maxToUse = maxUnits ? maxUnits : 8;
    let toReturn = [];
    for (let i = 1; i <= maxToUse; i++){
      toReturn.push(<MenuItem key={i} value={i}>{i} Units</MenuItem>)
    }
    return toReturn;
  }

  return (
    <FormControl fullWidth>
      <InputLabel id='num-units-label'> Filter by Number of Units</InputLabel>
    <Select
      labelId="num-units-label"
      label="Filter by Number of Units"
      value={value}
      onChange={setValue}
    >
      <MenuItem value={0}>No Filter</MenuItem>
      {buildOptions()}
      
    </Select>
    </FormControl>
  )
  
}